<template>
  <div class="wide-gate-input">
    <BField
      label="How wide is your gate?"
      :type="{ 'is-error': isInvalid }"
      :message="isInvalid ? 'This is required' : ''"
    >
      <div class="columns svg-wrapper">
        <LsClickable
          track-id="wide_gate_input-under_24"
          :class="[
            'gate-svg column right-border is-one-third',
            { 'wide_gate_input-mobile': isMobile && value === 'under24' },
          ]"
          test-id="under24"
          @click="onClick({ gateSize: 'under24' })"
          @mouseover="under24 = 'white'"
          @mouseleave="under24 = setColor({ gateSize: 'under24' })"
        >
          <Under24 :color="under24" test-id="under24-svg" />
          <p class="gate-label">Under 24"</p>
        </LsClickable>
        <LsClickable
          track-id="wide_gate_input-under_48"
          :class="[
            'gate-svg column right-border is-one-third',
            { 'wide_gate_input-mobile': isMobile && value === 'under48' },
          ]"
          test-id="under48"
          @click="onClick({ gateSize: 'under48' })"
          @mouseover="under48 = 'white'"
          @mouseleave="under48 = setColor({ gateSize: 'under48' })"
        >
          <Under48 :color="under48" test-id="under48-svg" />
          <p class="gate-label">Under 48"</p>
        </LsClickable>
        <LsClickable
          track-id="wide_gate_input-over_48"
          :class="[
            'gate-svg column is-one-third',
            { 'wide_gate_input-mobile': isMobile && value === 'over48' },
          ]"
          test-id="over48"
          @click="onClick({ gateSize: 'over48' })"
          @mouseover="over48 = 'white'"
          @mouseleave="over48 = setColor({ gateSize: 'over48' })"
        >
          <Over48 :color="over48" test-id="over48-svg" />
          <p class="gate-label">Over 48"</p>
        </LsClickable>
      </div>
    </BField>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { LsClickable } from '@/components/common';
import { lsDeviceHelpers, lsPropTypeHelpers } from 'ls-vue-common';
import { Under24, Under48, Over48 } from './Svgs';
import { lsColors } from '@/constants';

export default {
  name: 'WideGateInput',
  components: { LsClickable, Under24, Under48, Over48 },
  props: {
    value: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
    formDirty: VueTypes.bool.def(false),
  },
  data() {
    return {
      under24: this.setColor({ gateSize: 'under24' }),
      under48: this.setColor({ gateSize: 'under48' }),
      over48: this.setColor({ gateSize: 'over48' }),
      isMobile: lsDeviceHelpers.isMobile(),
    };
  },
  computed: {
    isInvalid() {
      return this.formDirty && !this.value;
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        if (this[newValue] === 'white') {
          return;
        }
        if (this.isMobile && this[newValue] !== 'white') {
          this[newValue] = 'white';
        } else {
          this[newValue] = lsColors.primary;
        }
      } else {
        this.resetAllColors();
      }
    },
  },
  methods: {
    resetAllColors() {
      this.under24 = lsColors['gray-tertiary'];
      this.under48 = lsColors['gray-tertiary'];
      this.over48 = lsColors['gray-tertiary'];
    },
    onClick({ gateSize }) {
      this.$emit('input', gateSize);
      this.resetAllColors();
      this[gateSize] = 'white';
    },
    setColor({ gateSize }) {
      if (this.value === gateSize) {
        return lsColors.primary;
      }
      return lsColors['gray-tertiary'];
    },
  },
};
</script>

<style lang="scss" scoped>
.wide-gate-input {
  max-width: 450px;
}

.svg-wrapper {
  padding-top: 5px;
  display: flex;
  justify-content: center;
}

.right-border {
  border-right: 1px solid $primary-light;
}

.gate-svg {
  padding-top: 15px;
  max-width: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: $primary;
  }
  &:hover .gate-label {
    color: $white;
  }
}

.gate-label {
  padding-top: 10px;
  text-align: center;
  user-select: none;
}

@media (max-width: $mobile-max-width) {
  .wide_gate_input-mobile {
    background-color: $primary;
    color: $white;
  }
}

.themed-app {
  .wide-gate-input {
    .right-border {
      border-color: $theme-color-primary-light;
    }
    .gate-svg {
      &:hover {
        background-color: $theme-color-primary;
      }
      &:hover .gate-label {
        color: $theme-color-white;
      }
    }
    .wide_gate_input-mobile {
      background-color: $theme-color-primary;
      color: $theme-color-white;
    }
  }
}
</style>
